import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Tag } from 'antd';
import moment from 'moment';
import { Link } from 'react-router-dom';
import { ContractIcon, AmendmentIcon } from '../../utils/constants/customIcon';
import {
  routes,
  subRoutes,
  outOfNavRoutes
} from '../../utils/constants/routes';
import useAuthContext from '../../contexts/AuthContext';

const useColumns = () => {
  const { t } = useTranslation();
  const { user } = useAuthContext();
  const customerView = user?.role === 'guests:GUEST';
  const [enums] = useState({
    statuses: ['RCP', 'PREVOYANCE', 'MRI', 'MRP']
  });

  const isWaitingSince = (documents) => {
    const array = [];
    // eslint-disable-next-line array-callback-return
    documents.map((doc) => {
      if (doc.status === 'MISSING' && doc.required === true) {
        array.push(doc.savedDate);
      }
    });
    return `${moment().diff(moment(array[0]), 'days')} jour${
      moment().diff(moment(array[0]), 'days') > 0 ? 's' : ''
    }`;
  };

  return [
    {
      title: t('contracts.column.number'),
      dataIndex: 'number',
      key: 'number',
      render: (number, { key }) => (
        <Link
          to={`${routes.CONTRACTS}${
            subRoutes.CONTRACTS.PORTFOLIO_CONTRACTS
          }/show/${key && key}`}
        >
          {number}
        </Link>
      ),
      sorter: true
    },
    {
      title: t('contracts.column.name'),
      dataIndex: 'customer',
      key: 'customer',
      render: (customer, { key }) => (
        <Link
          to={`${!customerView ? routes.CONTRACTS : ''}${
            !customerView ? subRoutes.CONTRACTS.PORTFOLIO_CLIENTS : ''
          }${customerView ? outOfNavRoutes.PROFILE : ''}${
            !customerView ? '/show/' : ''
          }${!customerView ? key : ''}`}
        >
          {`${customer.first_name} ${customer.last_name}`}
        </Link>
      ),
      sorter: true
    },
    {
      title: 'Type',
      dataIndex: 'type',
      key: 'type',
      filters:
        enums.statuses && enums.statuses.map((r) => ({ text: r, value: r }))
    },
    {
      title: 'Entreprise',
      dataIndex: 'customer',
      key: 'customer',
      render: (customer) => (
        <Link
          to={`${routes.CONTRACTS}${
            subRoutes.CONTRACTS.PORTFOLIO_CLIENTS
          }/show/${customer && customer._id}`}
        >
          {customer.company_name && `${customer.company_name}`}
        </Link>
      ),
      sorter: true
    },
    {
      title: 'Pièces manquantes',
      width: '15%',
      render: (record) => {
        return (
          <ul className="missing-parts-list">
            {record.documents.map((doc) => {
              if (doc.status === 'MISSING')
                if (doc.required)
                  return (
                    <li>
                      <Tag key={doc.name} className="withBorder">
                        {doc.amendmentNumber < 1 ? (
                          <ContractIcon />
                        ) : (
                          <AmendmentIcon />
                        )}
                        {t(`contractDocuments.${doc.name}`)}
                      </Tag>
                    </li>
                  );
              return null;
            })}
          </ul>
        );
      }
    },
    {
      title: t('contracts.column.waiting'),
      width: '150px',
      render: (record) => {
        return (
          <div style={{ textAlign: 'center' }}>
            <span style={{ color: '#f52323' }}>
              <strong>{isWaitingSince(record.documents)}</strong>
            </span>
          </div>
        );
      },
      sorter: true
    },
    {
      title: t('contracts.column.created_at'),
      dataIndex: 'created_at',
      key: 'created_at',
      render: (date) => date && moment(date).format('DD/MM/YYYY'),
      sorter: true
    }
  ];
};

export default useColumns;
